@if (widgetID) {
  <div class="{{ theme?.root }}">
    <div class="container {{ theme?.container }}">
      @if (vendorCommonNinja) {
        <div class="commonninja_component pid-{{ widgetID }}"></div>
      }
      @if (vendorAgolix) {
        <iframe sandbox="allow-scripts allow-forms" [src]="agolixIframeUrl" class="w-full" [style]="componentHeight" frameborder="0"></iframe>
      }
    </div>
  </div>
}